import React, {Component} from 'react';
import ReactDOM from 'react-dom';

// Components
import {Grid} from '@material-ui/core';
import {T} from 'Actions/translate';
import Dialog from 'Components/common/Dialog';
import BasicButton from 'Components/common/BasicButton';
import ShippingCounter from 'Components/counter/ShippingCounter';
import BasicDateInput from 'Components/common/BasicDateInput';
import Input from 'Components/common/Input';

// Icons
import {RemoveCircle} from '@material-ui/icons';

class ShippingPlanDialog extends Component {
    state = {
        skuInventoryExitOpened: false,
        expand: false,
        packageConditionCount: 0,

        shippingPlanExitOpened: false,
    };
    componentDidUpdate() {
        const dialogMask = ReactDOM.findDOMNode(
            document.getElementsByClassName('dialog-mask')[0],
        );
        if (dialogMask !== null && this.props.opened) {
            const dialogWrap = dialogMask.children[0];
            const dialogMaskHeight = dialogMask.clientHeight;
            const dialogWrapOffsetHeight = dialogWrap.offsetHeight;
            if (document.getElementById('skuConditionUl') !== null) {
                if (dialogMaskHeight !== 0 && dialogWrapOffsetHeight !== 0) {
                    if (dialogWrapOffsetHeight > dialogMaskHeight) {
                        document.getElementsByClassName(
                            'dialog-warp',
                        )[0].style.top = '0%';
                        document.getElementsByClassName(
                            'dialog-warp',
                        )[0].style.WebkitTransform = 'translateX(-50%)';
                    } else {
                        document.getElementsByClassName(
                            'dialog-warp',
                        )[0].style.top = '50%';
                        document.getElementsByClassName(
                            'dialog-warp',
                        )[0].style.WebkitTransform = 'translate(-50%, -50%)';
                    }
                }
            }
        }
    }

    closeDialog = (name) => {
        // document.getElementsByClassName('dialog-warp')[0].style.top = '50%';
        // document.getElementsByClassName(
        //     'dialog-warp',
        // )[0].style.WebkitTransform = 'translate(-50%, -50%)';
        // this.setState({expand: false});
        this.props.closeDialog(name);
    };

    shippingPlanQuantityChange = (value, currentIndex) => {
        this.props.eidtShippingPlanRQuantity(value, currentIndex);
    };

    handleChange = (title, value) => {
        this.props.eidtShippingDate(title, value);
    };

    submitShippingPlan = () => {
        const {currentOrderProduct, myOrderData} = this.props;

        this.props.saveShippingPlan(currentOrderProduct, myOrderData);
    };

    addShippingPlanModal = (skuQuantity) => {
        this.props.addShippingPlanItem(skuQuantity);
    };

    deletShippingPlanModal = (comps) => {
        this.props.deleteShippingPlan(comps);
    };

    getShippingPlansQuantity = () => {
        let currentshippingPlanData = JSON.parse(
            JSON.stringify(this.props.addedShippingPlanData),
        );

        console.log(
            'getShippingPlansQuantity================currentshippingPlanData',
            currentshippingPlanData,
        );
        let addedShippingPlanQuantity = 0;
        currentshippingPlanData.length > 0 &&
            currentshippingPlanData.map((shippingPlanItem) => {
                if (
                    typeof shippingPlanItem.id !== 'undefined' &&
                    shippingPlanItem.id
                ) {
                    addedShippingPlanQuantity += shippingPlanItem.quantity;
                }
            });

        return addedShippingPlanQuantity;
    };

    render() {
        const {
            opened,
            currentOrderProduct,
            addedShippingPlanData,
            currentTipMessage,
            showTip,
        } = this.props;

        console.log('currentTipMessage', currentTipMessage);

        return (
            <Dialog
                dialogDidClose={() =>
                    this.closeDialog('shippingPlanExitOpened')
                }
                opened={opened}
                options={{bgClickClose: true}}>
                <div className="shipping-plan-dialog">
                    <Grid className="dialog-title" container spacing={0}>
                        <Grid item xs={12}>
                            <span>{T('shipping_plan')}</span>
                        </Grid>
                    </Grid>

                    <Grid
                        className="dialog-content"
                        style={{color: '#605f5f'}}
                        container
                        spacing={0}
                        justify={'left'}>
                        <div className="shipping-plan-content-container">
                            {currentOrderProduct ? (
                                <div className="sku-container">
                                    <div>
                                        <label>{T('SKU')}: </label>
                                        {currentOrderProduct.product.sku}
                                    </div>
                                    <div>
                                        <label>
                                            {T('shipping_plan_all_quantity')}:{' '}
                                        </label>
                                        {currentOrderProduct.quantity}
                                    </div>
                                    <div>
                                        <label>
                                            {T(
                                                'shipping_plan_shipped_quantity',
                                            )}
                                            :{' '}
                                        </label>
                                        {currentOrderProduct.shippedQuantity +
                                            currentOrderProduct.receivedQuantity}
                                    </div>
                                </div>
                            ) : null}

                            {addedShippingPlanData.map((comps, index) => (
                                <div className="shipping-plan-item" key={index}>
                                    <div className="shipping-plan-item-row1">
                                        <div className="left-content">
                                            {/* <label>{T('shipping_plan_quantity')}</label> */}
                                            <ShippingCounter
                                                defalutValue={comps.quantity}
                                                currentSkuIndex={
                                                    comps.shippingPlanId
                                                }
                                                inputValid={
                                                    this
                                                        .shippingPlanQuantityChange
                                                }
                                                options={{
                                                    min: 1,
                                                    reduceBtnDisabled:
                                                        typeof comps.id !==
                                                            'undefined' &&
                                                        comps.id
                                                            ? true
                                                            : undefined,
                                                    plusBtnDisabled:
                                                        typeof comps.id !==
                                                            'undefined' &&
                                                        comps.id
                                                            ? true
                                                            : false,
                                                    valueDisabled:
                                                        typeof comps.id !==
                                                            'undefined' &&
                                                        comps.id
                                                            ? true
                                                            : false,
                                                }}
                                            />
                                            {/* <label>{T('shipping_plan_date')}</label> */}
                                            <BasicDateInput
                                                type={'date'}
                                                inputValid={this.handleChange}
                                                title={
                                                    'shippingDate-' +
                                                    comps.shippingPlanId
                                                }
                                                defaultValue={
                                                    comps.shippingDate
                                                }
                                                disabled={
                                                    typeof comps.id !==
                                                        'undefined' && comps.id
                                                        ? true
                                                        : false
                                                }
                                            />
                                        </div>
                                        <div className="right-content">
                                            <RemoveCircle
                                                onClick={() =>
                                                    this.deletShippingPlanModal(
                                                        comps.shippingPlanId,
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div
                            className={`current-tip-message ${
                                showTip ? 'show-message' : ''
                            }`}>
                            {T(currentTipMessage)}
                        </div>

                        <div className="add-shipping-plan-div">
                            <BasicButton
                                className="add-shipping-plan-btn"
                                onClickOfSingleTap={() =>
                                    this.addShippingPlanModal(
                                        currentOrderProduct.quantity,
                                    )
                                }>
                                <label className="plus-label">+</label>
                                {T('shipping_plan_dialog_add')}
                            </BasicButton>
                        </div>
                    </Grid>

                    <Grid
                        container
                        spacing={0}
                        className="shipping-plan-container">
                        <Grid item xs={12} align="center">
                            <BasicButton
                                className="action-btn close-confirm-btn"
                                type="primary"
                                disabled={false}
                                onClickOfSingleTap={() =>
                                    this.closeDialog('shippingPlanExitOpened')
                                }>
                                <span>{T('shipping_plan_dialog_cancel')}</span>
                            </BasicButton>
                            <BasicButton
                                className="action-btn submit-btn"
                                type="primary"
                                onClickOfSingleTap={() =>
                                    this.submitShippingPlan()
                                }>
                                <span>{T('shipping_plan_dialog_submit')}</span>
                            </BasicButton>
                        </Grid>
                    </Grid>
                </div>
            </Dialog>
        );
    }
}

export default ShippingPlanDialog;
